import Vue from 'vue';

export default {
    find(parametros) {
        return Vue.axios.get("catalogo-sat/tipo-nomina/find", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    get(id) {
        return Vue.axios.get("catalogo-sat/tipo-nomina/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    update(parametros) {
        return Vue.axios.put("catalogo-sat/tipo-nomina", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    delete(id) {
        return Vue.axios.delete("catalogo-sat/tipo-nomina/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    store(parametros) {
        return Vue.axios.post("catalogo-sat/tipo-nomina", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}